import { useSession } from '~hooks/useSession';
import { useGetBotAccessInfoQuery } from '~services/api/bots/endpoints';

export const useBotAccess = (recipientId = '') => {
	const { userId } = useSession();
	const skip = !userId || !recipientId;
	const { data: accessData, ...accessStates } = useGetBotAccessInfoQuery(
		{ userId, recipientId },
		{
			skip,
		}
	);
	const isDisabledByLevel =
		!accessData?.access && accessData?.reason === 'level';
	const isLoading = skip
		? false
		: accessStates.isLoading ||
		  accessStates.isFetching ||
		  accessStates.isUninitialized;

	return {
		...accessData,
		isDisabledByLevel,
		isLoading,
	};
};
